import { render } from "./my-address.vue?vue&type=template&id=1d0cc092&scoped=true"
import script from "./my-address.vue?vue&type=script&lang=js"
export * from "./my-address.vue?vue&type=script&lang=js"

import "./my-address.vue?vue&type=style&index=0&id=1d0cc092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0cc092"]])

export default __exports__